package devxertech.com.pages.industries.devIndustryEdu.innovativeAudience

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.industries.common.ManagementSoftware
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun InnovativeAudience() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 30.px, bottom = 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "EDUCATION MANAGEMENT SOFTWARE FOR EVERY NEED",
                asH2 = true,
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 18.px else 16.px,
                textAlign = TextAlign.Center,
                whiteSpace = WhiteSpace.PreWrap
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap).margin(top = 0.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "Innovative Yet",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700,
                    textTransform = TextTransform.Uppercase,
                    letterSpacing = 0.5.px
                )
                FieldTitleTextNormalSimple(
                    " Audience-Aligned",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700,
                    textTransform = TextTransform.Uppercase,
                    letterSpacing = 0.5.px
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 30.px)
                    .margin(leftRight = 0.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                ManagementSoftware(
                    image = Res.Image.audience_1,
                    imageWidth = 72.px,
                    imageHeight = 72.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Dedicated Dashboard", educationalChanges = true,
                    description = "Dedicated dashboards for students and teachers enable them to keep their activities " +
                            "organized and managed in accordance with their preferences and requirements. " +
                            "This feature also assists in making plan of scheduled classes."
                )
                ManagementSoftware(
                    image = Res.Image.audience_2,
                    imageWidth = 80.px,
                    imageHeight = 80.px,
                    sideImage = Res.Image.inovative_common,
                    title = "Effective Planning",
                    description = "Planning events and activities will no longer be a hassle as DEvxer " +
                            "comes up with effective and organized systems of planning so that each event " +
                            "is given its desired time, efforts and space to run smoothly. "
                )
                ManagementSoftware(
                    image = Res.Image.audience_3,
                    imageWidth = 83.px,
                    imageHeight = 83.px,
                    sideImage = Res.Image.inovative_common,
                    title = "management of\n" + "research projects",
                    description = "Research projects become fairly easy and convenient to manage as our platforms " +
                            "are interactive, highly efficient and custom-built to provide exceptional results of " +
                            "every project."
                )
                ManagementSoftware(
                    image = Res.Image.audience_4,
                    imageWidth = 93.px,
                    imageHeight = 93.px,
                    sideImage = Res.Image.inovative_common, educationChanges = true,
                    title = "Data Entry\n " +
                            "and Monitoring",
                    description = "Our software solutions make data entry and monitoring convenient, fast and " +
                            "seamless as they aim to reduce work pressure and confusion by organizing and monitoring " +
                            "data in depth and with efficiency."
                )
            }
        }
    }
}


